import { useUnsyncedWorkBanner } from './useUnsyncedWorkBanner';
import { useSessionExpiredBanner } from './useSessionExpiredBanner';
import { useOfflineLimitBanner } from './useOfflineLimitBanner';
import { useLowStorageBanner } from './useLowStorageBanner';
import { useUpdateBanner } from './useUpdateBanner';
import { useStorageProtectionBanner } from './useStorageProtectionBanner';

/**
 * Mounts the app- and device-wide producers of the global banner once, at the
 * app root. Renders nothing; `<GlobalBanner />` shows what they post.
 */
export default function AppBanners() {
  useSessionExpiredBanner();
  useOfflineLimitBanner();
  useLowStorageBanner();
  useUnsyncedWorkBanner();
  useUpdateBanner();
  useStorageProtectionBanner();
  return null;
}
